'use client'

import { motion } from 'framer-motion'
import React, { useEffect } from 'react'

import ManagementMandateModal from '@/core/components/modal/management-mandate'
import WelcomeModal from '@/core/components/modal/welcome'
import KycRequiredModal from '@/core/components/modal/kyc-required'
import DepositTransferModal from '@/core/components/modal/deposit-transfer';
import { useModalStore } from '@/store/modal/store';
import DvModal from '../modal/dv-modal';
import { useLocation } from 'react-router-dom';
import Footer from './footer';
import { getAccessToken } from '@/core/utils/auth0';
import Header from './header';
import StartDcaModal from '../modal/dca/start-dca'
import DcaQuestionnaireWrapper from '../modal/dca/dca-questionnaire-wrapper'
import BuyDvxModal from '../modal/buy-dvx'
import { useQueryClient } from '@tanstack/react-query'
import { BinanceService } from '@/core/services/binanceService'

export default function Content({ children }: { children: React.ReactNode }) {
  const { modal, setModal } = useModalStore();
  const location = useLocation();
  const pathname = location.pathname;
  const queryClient = useQueryClient();

  // Token refresh interval
  useEffect(() => {
    const tokenRefreshInterval = setInterval(() => {
      getAccessToken();
    }, 30 * 60 * 1000);

    return () => clearInterval(tokenRefreshInterval);
  }, []);

  // Prefetch accounts data on financial pages for instant Transfer modal
  useEffect(() => {
    const shouldPrefetch = pathname.includes('main-account') || 
                           pathname.includes('exchange') ||
                           pathname.includes('dca-strategy') ||
                           pathname.includes('management-mandate') ||
                           pathname === '/';
    
    if (shouldPrefetch) {
      const interval = setInterval(() => {
        queryClient.prefetchQuery({
          queryKey: ['allAccounts'],
          queryFn: () => BinanceService.getAllAccount(),
        });
      }, 30000); // Prefetch every 30 seconds
      
      // Initial prefetch
      queryClient.prefetchQuery({
        queryKey: ['allAccounts'],
        queryFn: () => BinanceService.getAllAccount(),
      });
      
      return () => clearInterval(interval);
    }
  }, [pathname, queryClient]);

  return (
    <>
      <div id="content" className="custom-scrollbar">
        <Header />
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            type: 'spring',
            stiffness: 214,
            damping: 30,
            mass: 1,
            delay: 0.8,
          }}
          className="px-0 md:px-6 lg:px-[33px]"
          style={{
            display: 'flex',
            minHeight: 'calc(100vh - 90px)',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          {children}
          <Footer />
        </motion.div>
      </div>
      <DvModal open={!!modal.startDca} onClose={() => setModal({ startDca: false })}>
        <StartDcaModal onClose={() => setModal({ startDca: false })} />
      </DvModal>
      <DvModal open={!!modal.dcaQuestionnaire} onClose={() => setModal({ dcaQuestionnaire: false })}>
        <DcaQuestionnaireWrapper onClose={() => setModal({ dcaQuestionnaire: false })} />
      </DvModal>
      <DvModal open={!!modal.deposit || !!modal.transfer || !!modal.withdraw } onClose={() => setModal({ deposit: false, transfer: false, withdraw: false })}>
        <DepositTransferModal />
      </DvModal>
      <ManagementMandateModal />
      <WelcomeModal />
      <KycRequiredModal />
      <DvModal open={!!modal.buyDvx} onClose={() => setModal({ buyDvx: false })}>
        <BuyDvxModal />
      </DvModal>
    </>
  )
}